// NOTE: can expand beyond light & dark
export enum ThemeKey {
  Default = "light",
  Dark = "dark",
}
